import React, { useEffect, useMemo } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector, useDispatch } from "react-redux";
import { closeToast } from "../slices/toast/reducer";

const DEFAULT_OPTIONS = {
  position: "top-right",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "light",
};

function removeHtmlTags(input) {
  if (typeof input !== "string") {
    return input;
  }
  return input.replace(/<[^>]*>/g, "");
}

function ToastComponent() {
  const toastState = useSelector((state) => state.toast) || {};
  const { type = "success", open = false, msg = "", options = {} } = toastState;
  const dispatch = useDispatch();

  const cleanedMsg = removeHtmlTags(msg);
  const toastOptions = useMemo(
    () => ({ ...DEFAULT_OPTIONS, ...options }),
    [options]
  );

  useEffect(() => {
    if (open && cleanedMsg) {
      const toastType = type || "success";

      switch (toastType) {
        case "success":
          toast.success(cleanedMsg, toastOptions);
          break;
        case "warning":
          toast.warning(cleanedMsg, toastOptions);
          break;
        case "info":
          toast.info(cleanedMsg, toastOptions);
          break;
        case "error":
          toast.error(cleanedMsg, toastOptions);
          break;
        default:
          toast(cleanedMsg, toastOptions);
          break;
      }

      const timer = setTimeout(() => {
        dispatch(closeToast());
      }, toastOptions.autoClose || DEFAULT_OPTIONS.autoClose);

      return () => clearTimeout(timer);
    }
  }, [open, type, cleanedMsg, dispatch, toastOptions]);

  return (
    <ToastContainer
      position={toastOptions.position}
      autoClose={toastOptions.autoClose}
      hideProgressBar={toastOptions.hideProgressBar}
      newestOnTop={false}
      closeOnClick={toastOptions.closeOnClick}
      rtl={toastOptions.rtl}
      pauseOnFocusLoss
      draggable={toastOptions.draggable}
      pauseOnHover={toastOptions.pauseOnHover}
      theme={toastOptions.theme}
    />
  );
}

export default ToastComponent;
